<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.40422 11.6001C5.95722 11.6001 5.57817 11.4458 5.26706 11.1373C4.95595 10.8286 4.80039 10.4508 4.80039 10.0039C4.80039 9.55693 4.95467 9.17788 5.26322 8.86676C5.57189 8.55565 5.94967 8.4001 6.39656 8.4001C6.84356 8.4001 7.22261 8.55438 7.53372 8.86293C7.84483 9.1716 8.00039 9.54938 8.00039 9.99626C8.00039 10.4433 7.84611 10.8223 7.53756 11.1334C7.22889 11.4445 6.85111 11.6001 6.40422 11.6001ZM3.60039 14.4001C3.27039 14.4001 2.98789 14.2807 2.75289 14.0418C2.51789 13.8029 2.40039 13.5223 2.40039 13.2001V4.4001C2.40039 4.07788 2.51789 3.79732 2.75289 3.55843C2.98789 3.31954 3.27039 3.2001 3.60039 3.2001H4.80039V1.6001H6.00039V3.2001H10.0004V1.6001H11.2004V3.2001H12.4004C12.7304 3.2001 13.0129 3.31954 13.2479 3.55843C13.4829 3.79732 13.6004 4.07788 13.6004 4.4001V13.2001C13.6004 13.5223 13.4829 13.8029 13.2479 14.0418C13.0129 14.2807 12.7304 14.4001 12.4004 14.4001H3.60039ZM3.60039 13.2001H12.4004V7.2001H3.60039V13.2001ZM3.60039 6.0001H12.4004V4.4001H3.60039V6.0001Z"
      fill="#383838"
    />
  </svg>
</template>
